import * as crypto from "crypto";

// List of funky adjectives and nouns
const adjectives = [
  "Blazing",
  "Dizzy",
  "Groovy",
  "Funky",
  "Sizzling",
  "Wacky",
  "Zesty",
  "Jazzy",
  "Snazzy",
  "Quirky",
  "Whacky",
  "Vibing",
  "Bouncy",
  "Zippy",
  "Cheeky",
  "Spunky",
  "Swanky",
  "Zonky",
  "Chirpy",
  "Frothy",
];

const nouns = [
  "Unicorn",
  "Tiger",
  "Robot",
  "Dragon",
  "Phoenix",
  "Pirate",
  "Ninja",
  "Wizard",
  "Alien",
  "Zombie",
  "Dinosaur",
  "Astronaut",
  "Monkey",
  "Penguin",
  "Llama",
  "Sphinx",
  "Panther",
  "Shark",
  "Yeti",
];

// Function to generate the funky name
export function getFunkyName(inputString: string): string {
  // Hash the input string using SHA-256
  const hash = crypto.createHash("sha256").update(inputString).digest("hex");

  // Convert the hash to a large integer
  const hashInt = BigInt(`0x${hash}`);

  // Map the hash to an adjective and noun
  const adjective = adjectives[Number(hashInt % BigInt(adjectives.length))];
  const noun =
    nouns[Number((hashInt / BigInt(adjectives.length)) % BigInt(nouns.length))];

  return `${adjective} ${noun}`;
}
